<style>
.zoezi-resourcebooking-container {
  display: grid;
  width: 100%;
  grid-template-columns: auto 0.7fr 1fr auto;
  grid-template-rows: 0.5fr 2fr;
  grid-template-areas:
    "icon header header header"
    "icon staff attributes buttons";
}

@media (max-width: 620px) {
  .zoezi-resourcebooking-container {
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr auto auto;
    grid-template-areas:
      "icon header"
      "icon staff"
      "attributes attributes"
      "buttons buttons";

    .zoezi-attributedisplay {
      display: flex;
      align-items: center;
    }
  }
}

@media (max-width: 320px) {
  .zoezi-resourcebooking-container {
    grid-template-rows: auto auto auto auto;

    .zoezi-square {
      display: none !important;
    }
  }
}
</style>
<template>
    <div class="zoezi-resourcebooking-container">
        <!-- Title -->
        <div style="grid-area: header;" class="pt-1 pl-2">
            <strong>
                {{ booking.text }}
            </strong>
        </div>

        <!-- Image -->
        <div class="zoezi-square d-flex" style="grid-area: icon;">
            <div class="z-card-image" :style="{
                'background-image':
                    'url(' + $api.getImageUrl(booking.imagekey, 100) + ')',
            }">
                <div class="z-card-image-time" :style="getBookingColorStyle">
                    {{ booking.start.hhmm() }}
                </div>
                <div class="z-card-image-small" :style="getBookingColorStyle">
                    {{ booking.duration }} {{$translate('MINUTES_SHORT')}}
                </div>
            </div>
        </div>

        <!-- Staff Image/Name -->
        <div style="grid-area: staff" class="pa-2">
            <div class="zoezi-checkout-summary-resource-booking-resource d-flex mr-5">
                <div class="justify-center align-center">
                    <v-avatar size="45" v-if="booking.rb.staff_imagekey" class="mr-5">
                        <v-auto-img class="zoezi-staff-image" :src="$api.getImageUrl(booking.rb.staff_imagekey, 100)" />
                    </v-avatar>
                </div>
                <span class="d-flex flex-column align-start justify-center">
                    <div style="font-size: 0.8em">
                        {{ booking.rb.staffname }}
                    </div>
                    <div v-if="this.booking.rb.extra_resource_location" style="font-size: 0.8em">
                        <v-icon small color="black" class="mr-2">mdi-map</v-icon>
                        {{ this.booking.rb.extra_resource_location.name }}
                    </div>
                </span>
            </div>
        </div>

        <!-- Attributes / Info -->
        <div style="grid-area: attributes" class="pa-2">
            <div class="zoezi-checkout-summary-resource-booking-details d-flex justify-start flex-wrap text-left">
                <div v-if="contactInfo" class="ma-1">
                    <v-icon small color="black" class="mr-2">mdi-map-marker</v-icon>
                    {{ contactInfo.address }} {{ contactInfo.zipCode }} {{ contactInfo.city }}
                </div>
                <div class="ma-1">
                    <v-icon small color="black" class="mr-2">mdi-calendar-month-outline</v-icon>
                    {{ Date.formatTimeFullRelative(booking.start) }}
                </div>
                <div class="ma-1">
                    <v-icon small color="black" class="mr-2">mdi-clock-outline</v-icon>
                    {{ booking.rb.duration }} {{$translate('MINUTES_SHORT')}}
                </div>
                <div v-if="booking.rb.payment" class="ma-1">
                    <v-icon small color="black" class="mr-2">mdi-ticket-outline</v-icon>
                    {{ booking.rb.payment.amount | price }}
                </div>
            </div>
        </div>

        <!-- Buttons -->
        <div class="ma-2 d-flex justify-end align-end" style="grid-area: buttons">
            <div style="width: 5em">
                <v-btn block @click.stop="cancelBooking()" text color="error" v-if="booking.rb.unbookable">
                    {{$translate('CANCEL_BOOKING')}}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "zoezi-my-rb-card",

    props: {
        booking: null,
    },

    computed: {
        contactInfo() { // Priority: Resource with address => extraResource/locationResource => Site Address => Visit address => address
            if (this.booking.rb.resource_location?.address) {
                return this.booking.rb.resource_location;
            }

            if (this.booking.rb.extra_resource_location?.address) {
                return this.booking.rb.extra_resource_location;
            }

            if (this.booking.rb.optional_resources?.length >= 1 && this.booking.rb.optional_resources[0].address) {
                return this.booking.rb.optional_resources[0];
            }

            if (this.$store.state.settings?.sites?.length > 1) { // Fleranläggning
                const site = this.$store.state.settings.sites.find(s => s.id == this.booking.rb.site_id);
                return site;
            }

            const location = this.$store.state.settings.contactinfo;
            if (location.visit_address && location.visit_city && location.visit_zipCode) {
                return { address: location.visit_address, city: location.visit_city, zipCode: location.visit_zipCode };
            }

            return location;
        },
        getBookingColorStyle() {
            return {
                "background-color": this.booking.color
                    ? this.booking.color + "b4"
                    : "rgba(192,160,0,0.7)",
            };
        }
    },

    methods: {
        cancelBooking() {
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('Cancel'),
                text: this.$translate('Are you sure you want to cancel {0}?').format(this.booking.text),
                actionText: this.$translate('CANCEL_BOOKING'),
                action: () => {
                    this.$api
                        .post("/api/memberapi/resourcebooking/cancel", null, {
                            id: this.booking.id,
                        })
                        .then((response) => {
                            this.loading = false;

                            if (!response.ok) {
                                this.$store.commit('showErrorDialog', {
                                    title: this.$translate('Cancellation error'),
                                    text: this.$translate('The booking could not be cancelled')
                                });
                            }

                            this.showDialog = !response.ok;
                        });
                }
            });
        },
    },
};
</script>
